export { FastForward as default } from './FastForward';
